// import routes from "@/routes/routes.mjs";
import lolRefs from "@/game-lol/refs.mjs";
import hasQueryString from "@/util/has-query-string.mjs";
import { initABFeature } from "@/util/use-ab-feature.mjs";

const FEATURE_AB_PERCENTAGE = 33;

export async function setup() {
  const enabled =
    (await initABFeature(
      ["coaching", "lol-postmatch-coaching"],
      FEATURE_AB_PERCENTAGE,
    )) || hasQueryString("__BLITZ_COACHING__");

  if (!enabled) return;

  const component = await import("feature-lol-coaching/PostMatchCoaching.jsx");
  lolRefs.PostMatchCoachingSection = component.default;
}

export function teardown() {
  lolRefs.PostMatchCoachingSection = null;
}
